import { createAction } from '@reduxjs/toolkit'
import { Toast } from './types'

/**
 * Actions do módulo UI
 */
export const uiActions = {
  // Toast actions
  addToast: createAction<Toast>('ui/addToast'),
  removeToast: createAction<string>('ui/removeToast'),
  clearToasts: createAction('ui/clearToasts'),
  
  // Helper actions (criarão o toast automaticamente)
  showSuccess: createAction<{ title: string; message?: string; duration?: number }>('ui/showSuccess'),
  showError: createAction<{ title: string; message?: string; duration?: number }>('ui/showError'),
  showWarning: createAction<{ title: string; message?: string; duration?: number }>('ui/showWarning'),
  showInfo: createAction<{ title: string; message?: string; duration?: number }>('ui/showInfo'),
}

